import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { TbSmartHome } from "react-icons/tb";
import { IoArrowDownCircleOutline } from "react-icons/io5";
import { useNavigate, useLocation } from "react-router-dom";

import PanelLayout from "layouts/PanelLayout";
import boy from "assets/layout_img/boy.svg";
import "styles/teacher.css";

const StudentDocPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const menuRef = useRef(null);

  const subject = location.state?.subject || { title: "Fan nomi" };

  const [docs, setDocs] = useState([
    {
      id: 1,
      img: boy,
      title: "O'quv dasturi",
      desc: "Ushbu hujjat o'quv dasturini o'z ichiga oladi",
      buttonText: "Yuklab olish",
    },
    {
      id: 2,
      img: boy,
      title: "Dars rejalari",
      desc: "Ushbu hujjat dars rejalari bilan tanishish imkonini beradi",
      buttonText: "Yuklab olish",
    },
    {
      id: 3,
      img: boy,
      title: "Baholash mezonlari",
      desc: "Ushbu hujjat baholash mezonlarini o'z ichiga oladi",
      buttonText: "Yuklab olish",
    },
  ]);

  const [activeMenu, setActiveMenu] = useState(null);
  const [viewDoc, setViewDoc] = useState(null);
  const [editingDoc, setEditingDoc] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [editDesc, setEditDesc] = useState("");

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setActiveMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleMenu = (id) => {
    setActiveMenu((prev) => (prev === id ? null : id));
  };

  const openViewModal = (doc) => {
    setViewDoc(doc);
    setActiveMenu(null);
  };

  const openEditModal = (doc) => {
    setEditingDoc(doc);
    setEditTitle(doc.title);
    setEditDesc(doc.desc);
    setActiveMenu(null);
  };

  const saveChanges = () => {
    if (!editingDoc) return;

    setDocs((prev) =>
      prev.map((d) =>
        d.id === editingDoc.id
          ? { ...d, title: editTitle.trim(), desc: editDesc.trim() }
          : d
      )
    );

    setEditingDoc(null);
    setEditTitle("");
    setEditDesc("");
  };

  const deleteDocument = (id) => {
    if (!window.confirm("Haqiqatan ham o‘chirilsinmi?")) return;

    setDocs((prev) => prev.filter((d) => d.id !== id));
    setActiveMenu(null);
  };

  return (
    <PanelLayout>
      <div className="subject-page">
        <div className="tests-header">
          <div className="breadcrumb">
            <span onClick={() => navigate("/student")}>
              <TbSmartHome
                style={{ fontSize: 20, color: "#01CC0D", cursor: "pointer" }}
              />
            </span>
            <span className="divider">/</span>
            <span
              onClick={() => navigate(-1)}
              style={{ cursor: "pointer", color: "#01CC0D" }}
            >
              {subject.title}
            </span>
            <span className="divider">/</span>
            <span className="current">Hujjatlar</span>
          </div>
        </div>

        <motion.div
          className="doc-wrap"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <AnimatePresence mode="wait">
            {docs.map((doc, index) => (
              <motion.div
                key={doc.id}
                className="doc-card"
                layout
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -30 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -6, transition: { duration: 0.2 } }}
              >
                <img
                  src={doc.img}
                  alt={doc.title}
                  className="doc-img"
                  loading="lazy"
                />

                <div className="doc-header">
                  <h3 className="doc-title" title={doc.title}>
                    {doc.title}
                  </h3>
                </div>

                <p className="doc-desc">{doc.desc}</p>

                <button className="download-btn">
                  <IoArrowDownCircleOutline style={{ fontSize: 20 }} />
                  {doc.buttonText}
                </button>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        <AnimatePresence>
          {viewDoc && (
            <motion.div
              className="modal-backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setViewDoc(null)}
            >
              <motion.div
                className="modal-content"
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.9, opacity: 0 }}
                onClick={(e) => e.stopPropagation()}
              >
                <h2>{viewDoc.title}</h2>
                <p style={{ margin: "16px 0", lineHeight: 1.6 }}>
                  {viewDoc.desc}
                </p>
                <button
                  onClick={() => setViewDoc(null)}
                  className="close-modal-btn"
                >
                  Yopish
                </button>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>

        <AnimatePresence>
          {editingDoc && (
            <motion.div
              className="modal-backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setEditingDoc(null)}
            >
              <motion.div
                className="modal-content"
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.9, opacity: 0 }}
                onClick={(e) => e.stopPropagation()}
              >
                <h2>Hujjatni tahrirlash</h2>

                <input
                  type="text"
                  value={editTitle}
                  onChange={(e) => setEditTitle(e.target.value)}
                  placeholder="Sarlavha"
                  className="modal-input"
                />

                <textarea
                  value={editDesc}
                  onChange={(e) => setEditDesc(e.target.value)}
                  placeholder="Tavsif"
                  rows={5}
                  className="modal-textarea"
                />

                <div className="modal-actions">
                  <button onClick={saveChanges} className="save-btn">
                    Saqlash
                  </button>
                  <button
                    onClick={() => setEditingDoc(null)}
                    className="cancel-btn"
                  >
                    Bekor qilish
                  </button>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </PanelLayout>
  );
};

export default StudentDocPage;
